import React from 'react';
import { Button, useWidth, Box } from 'vindi-ds-components';
import styles from './styles';
import ScaffoldCard from './scaffold_card';

function IncompleteCard({ ...props }) {
  const {
    buttonLabel, isCompleted, link, gtm,
  } = props;
  const mobile = ['xs', 'sm', 'md'].includes(useWidth());

  const Links = () => (
    <Box display='flex' flexDirection='row' alignItems='center'>
      <Button id={gtm} href={link} variant='secondary' style={styles.buttonStyle} width={mobile ? '100%' : '230px'}>
        {buttonLabel}
      </Button>
    </Box>
  );
  return (
    <ScaffoldCard
      CardLinks={Links}
      iconColor='#999999'
      css={styles.incomplete}
      {...props}
      isCompleted={isCompleted}
    />
  );
}

export default IncompleteCard;
